<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <FeesForSecurityForm
        ref="feesForSecurityForm"
        v-model="feesForSecurityForm"
        label-width="10em"
        formMode="search"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForSecurityForm from '@/components/organisms/dialog/calculation/FeesForSecurityForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FeesForSecurityForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      feesForSecurityForm: {
        billing_ym: this.getDefaultBillingYm(),
        bill_to_code: undefined,
        destination_airport_code: undefined,
        route_code: undefined,
        tax: undefined,
        taxation: undefined,
        paid_passengers: undefined,
        passenger_fee: undefined,
        paid_cargo_volume: undefined,
        cargo_volume_fee: undefined,
        // 2022/05/06 髙森 追記 旅客数保安料と貨物量保安料
        passenger_security_fee_with_tax: undefined,
        cargo_security_fee_with_tax: undefined,
        // ここまで
        security_fee_without_tax: undefined,
        security_fee_tax: undefined,
        security_fee_with_tax: undefined,
        manual_data_only: false,
        automatic_data_only: false
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterDetailSearchDialog.mounted')
  },
  methods: {
    clickClear () {
      this.$refs.feesForSecurityForm.clearFields()
    },
    clickSearch () {
      this.$refs.feesForSecurityForm.validate()
        .then((valid) => {
          sessionStorage.setItem('feesForSecuritySearchCond', JSON.stringify(this.feesForSecurityForm))
          this.dialogVisible = false
          this.$emit('search', this.feesForSecurityForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForSecuritySearchCond'))
      this.$nextTick(() => {
        this.$refs.feesForSecurityForm.clearFields()
        if (searchCond) {
          Object.keys(this.feesForSecurityForm).forEach((x) => {
            this.$set(this.feesForSecurityForm, x, searchCond[x])
          })
          if (!this.feesForSecurityForm.manual_data_only) {
            this.feesForSecurityForm.manual_data_only = false
          }
          if (!this.feesForSecurityForm.automatic_data_only) {
            this.feesForSecurityForm.automatic_data_only = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
